import React from "react";
import {IActiveOrder} from "./contracts/types";
import {numberToCurrency} from "../services/globals";
import {WEBSERVER} from "../services/globals"

const checkout1url:string = WEBSERVER + "/checkout1";

interface Props {
  activeOrder: IActiveOrder | null;
  removeItemFromOrder: (id: number) => void;
  changeCartLine: (id: number, qty: number) => void;
  setLineQuantity: (id: number, value : number) => void;
  editable: boolean;
}

export const CartTable: React.FC<Props> = ({
  activeOrder,
  removeItemFromOrder,
  changeCartLine,
  setLineQuantity,
  editable = true
}) => {
  return (
    <React.Fragment>
      {activeOrder !== null && (
        <table className="warenkorb table-sm">
          <thead className="header">
            <tr>
              <th  className="">
              Produkt
              </th>
              <th >
              Anzahl
              </th>
              <th>
              Preis
              </th>
              <th align="right">
              Gesamtpreis
              </th>
            </tr>
          </thead>
          <tbody className="body">
            {activeOrder &&
              activeOrder != null &&
              activeOrder?.activeOrder?.lines.map((line) => {
                let xname ="input" + line.id;
                return (
                  <tr key={line.id}>
                    <td className="">
                    {line.productVariant.name}
                    </td>
                    <td className="">
                      <div className="">
                        <div className="input-group">
                        {editable ?
                        <div> 
                          <input id={xname} className="form-control count-input" type="number" value={line.quantity as any as string} name={xname}
                           onChange={e => setLineQuantity(line.id as any as number,parseInt(e.target.value))}>
                          </input>

                          <button className="btn btn-secondary" onClick={() => changeCartLine(line.id,line.quantity)} >ändern</button>
                        </div> : <div className="linequantity">{line.quantity}</div>} 

                          {editable ? 
                          <button
                            className="cursor-pointer btn btn-warn"
                            onClick={() => removeItemFromOrder(line.id)}
                          >
                            löschen
                          </button> 
                          : <div></div>}
                        </div>
                      </div>
                    </td>
                    <td className="">
                      <div className="">{numberToCurrency(line.unitPriceWithTax)}</div>
                    </td>
                    <td className="" align="right">
                      {numberToCurrency(line.unitPriceWithTax * line.quantity)}
                    </td>
                  </tr>
                );
              })}
            <tr>
            <td colSpan={2}> </td> 
              <td  align="left">
                <strong>Versand</strong>
              </td>
              <td colSpan={3} align="right">
                {numberToCurrency(activeOrder?.activeOrder?.shippingWithTax || 0)}
              </td>
            </tr>
            <tr>
            <td colSpan={2}> </td> 
              <td  align="left">
                <strong>Preis netto</strong>
              </td>
              <td colSpan={3} align="right">
                {numberToCurrency(activeOrder?.activeOrder?.total || 0)}
              </td>
            </tr>
            <tr>
            <td colSpan={2}> </td>
              <td>
                <strong>Preis mit MWST</strong>
              </td>
              <td colSpan={3} align="right">
                {numberToCurrency(activeOrder?.activeOrder?.totalWithTax || 0)}
              </td>
            </tr>
            {editable?
            <tr><td colSpan={6}>
            <div className="d-flex flex-row-reverse pt-4">
            <a className="btn btn-primary btn-lg" href={checkout1url}>Zur Kasse</a>
            </div>
            </td></tr>
             :
            <tr></tr> }
          </tbody>
        </table>
      )}
    </React.Fragment>
  );
};

export default CartTable;
